import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Tab from './Top/Tab';
import StepMenu from './Top/StepMenu';

const propTypes = {
};

const defaultProps = {
};

class TopMenu extends Component {

  constructor(props) {
    super(props);
  }

  render() {

    const { fn, data } = this.props;
    const tab = {
      fn : {
        tabMove : fn.tabMove
      },
      data : {
        tabType : data.topMenu.tabType
        , auth : data.auth
      }
    }

    const step = {
      fn : {
        stepMove : fn.stepMove
      },
      data : {
        nowStep : data.topMenu.nowStep
        ,tabType : data.topMenu.tabType
      }
    }

    return(
      <div className="top-menu">
        <Tab
          fn={tab.fn}
          data={tab.data}
        />
        <StepMenu
          fn={step.fn}
          data={step.data}
        />
      </div>
    );
  }
}

TopMenu.propTypes = propTypes;
TopMenu.defaultProps = defaultProps;

export default TopMenu;
